import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { Router } from '@angular/router';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
import { Subscription } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
@Component({
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule, MatIconModule],
  selector: 'app-revision',
  templateUrl: './revision.component.html',
  styleUrls: ['./revision.component.css'],
})
export class RevisionComponent implements OnInit {
  projectIdNew: string;
  latestVersion: any;
  constructor(
    private router: Router,
    private projectsService: ProjectsService,
    private cdr: ChangeDetectorRef,
    private GetProjectIdService: GetProjectIdService
  ) {}
  private subscription: Subscription = new Subscription();

  revisions: any[] = [];
  randomId = 1;
  ngOnInit(): void {
    this.fetchProjectVersions();
    this.projectIdNew = this.GetProjectIdService.getProjectId();
  }

  fetchProjectVersions(): void {
    this.projectsService.getProjectRevision().subscribe({
      next: (response: any) => {
        this.createRevisions(response?.data);
      },
      error: (error: any) => {
        console.error('Error fetching the project revision:', error);
      },
    });
  }
  createRevisions(data: any) {
    console.log('createRevisions -> data', data);

    this.latestVersion = data['latest_version'];
    const _data = data['history'];
    const revisions = [];
    _data.forEach((rev, index) => {
      console.log('rev', rev, index);
      const rec = {
        id: rev['project_revision_no'],
        version: `v${index + 1}`,
        dateModified: rev['last_modified_at'] ? rev['last_modified_at'] : '--',
        modifiedBy: rev['last_modified_by']
          ? rev['last_modified_by']
          : 'System Generated',
      };
      console.log('rev record', rec);
      revisions.push(rec);
    });

    this.revisions = revisions;

    // Sort revisions by version in descending order
    this.revisions.sort(
      (a, b) => parseInt(b.version.slice(1)) - parseInt(a.version.slice(1))
    );
  }
  getRandomDate(): string {
    const start = new Date(2023, 0, 1);
    const end = new Date();
    const date = new Date(
      start.getTime() + Math.random() * (end.getTime() - start.getTime())
    );
    return date.toLocaleDateString();
  }
  handleClose() {
    this.router.navigate([`/projects`]);
  }

  navigateToLatestVersionViewMode() {
    this.router.navigate(['/brief-plan-view']);
  }

  navigateToOldVersionViewMode(revisionId: number) {
    this.router.navigate(['/brief-history-viewmode'], {
      queryParams: { revisionId },
    });
  }
}
